import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { cloneDeep } from 'lodash';

import { dateService } from '../../../services/date';
import { creatorWorkspaceService } from './creator-workspace-service';

import Icon from '../../ui/icon';
import MocksButton from '../../misc/mocks-button';
import ModuleOptions from './module-options';
import ModuleModal from './module-modal';
import { Table, Column } from '../../ui/table';

import './category-breakdown.scss';

const CategoryBreakdown = () => {
  const [showMocks, setShowMocks] = useState(true);
  const [category, setCategory] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [reordering, setReordering] = useState(false);

  const disabled = category && category.modules.length < 2;

  // useEffect(() => {
  //   getCategory();
  // }, []);

  useEffect(() => {
    if (showMocks) {
      setCategory(creatorWorkspaceService.getMockCategory());
    }
  }, [showMocks]);

  async function getCategory() {
    try {
      const res = await creatorWorkspaceService.getCategory();
      setCategory(res.data.data[0]);
    } catch {
      setCategory(null);
    }
  }

  function handleSetModules(newModules) {
    const newCategory = cloneDeep(category);
    newCategory.modules = newModules;
    setCategory(newCategory);
  }

  const columns = [
    {
      dataKey: 'options',
      label: '',
      width: 1,
      cellRender: ({ rowData, rowIndex }) =>
        reordering ? (
          <div className="drag-drop-icon">
            <Icon iconName="kebab" size={25} />
            <Icon iconName="kebab" size={25} />
          </div>
        ) : (
          <ModuleOptions mod={rowData} />
        ),
    },
    {
      dataKey: 'rank',
      label: '',
      width: 1,
    },
    {
      dataKey: 'module_type',
      label: 'Module Type',
      width: 3,
    },
    {
      dataKey: 'module_title',
      label: 'Module Title',
      width: 3,
    },
    {
      dataKey: 'impressions',
      label: 'Impressions',
      width: 2,
      justifyContent: 'right',
      cellRender: ({ cellData, rowData }) =>
        cellData && !rowData.is_default ? cellData : <span className="dash"></span>,
      labelRender: ({ label }) => (
        <div>
          <div className="label">{label}</div>
          <div className="sublabel">Last 7 Days</div>
        </div>
      ),
    },
    {
      dataKey: 'clicks',
      label: 'Clicks',
      width: 1,
      justifyContent: 'right',
      cellRender: ({ cellData, rowData }) =>
        cellData && !rowData.is_default ? cellData : <span className="dash"></span>,
      labelRender: ({ label }) => (
        <div>
          <div className="label">{label}</div>
          <div className="sublabel">Last 7 Days</div>
        </div>
      ),
    },
    {
      dataKey: 'last_updated',
      label: 'Last Updated',
      width: 2,
      justifyContent: 'right',
      cellRender: ({ cellData, rowData }) =>
        cellData && !rowData.is_default ? (
          dateService.formatDisplayDate(cellData)
        ) : (
          <span className="dash"></span>
        ),
    },
    {
      dataKey: 'status',
      label: 'Status',
      width: 1,
      justifyContent: 'right',
    },
    {
      dataKey: 'preview',
      label: 'Preview',
      width: 1,
      justifyContent: 'center',
      cellRender: ({ cellData }) => <Icon iconName="eye" size={13} />,
    },
  ];

  const columnItems = columns.map((column, index) => (
    <Column
      key={index}
      dataKey={column.dataKey}
      label={column.label}
      width={column.width}
      flexWidth={true}
      sortable={column.sortable}
      justifyContent={column.justifyContent}
      cellRender={column.cellRender}
      labelRender={column.labelRender}
    />
  ));

  const table = category ? (
    <Table
      data={category.modules}
      rowIdField="category_id"
      setData={handleSetModules}
      orderable={reordering}
    >
      {columnItems}
    </Table>
  ) : null;

  const moduleModal = showModal ? <ModuleModal setShowModal={setShowModal} /> : null;

  return (
    <div className="category-breakdown">
      <MocksButton setShowMocks={setShowMocks} showMocks={showMocks} />
      {moduleModal}
      <Link className="go-back" to={`/v2/admin/creator-workspace/content-manager`}>
        <span className="arrow-left"></span>
        <span className="text">Back to Content Manager</span>
      </Link>
      <div className="header">
        {category && category.name}
        <span className="creator-quantity">{category && category.creators} Creators</span>
      </div>
      <div className="content">
        <button className="build-a-module" onClick={() => setShowModal(true)}>
          Build A Module
        </button>
        <button className="reorder" onClick={() => setReordering(!reordering)} disabled={disabled}>
          {!reordering ? 'Reorder' : 'Cancel'}
        </button>
        {table}
      </div>
    </div>
  );
};

export default CategoryBreakdown;
